module.exports = __webpack_public_path__ + "img/fwzc-02.a05d4c9b.jpg";